import { useState } from "react";
import { get, put, post } from "../api";
import { QueryClient, useQuery, useMutation } from "@tanstack/react-query";

const queryClient = new QueryClient();

async function addPromotion(promotion) {
  return await post("/discount_codes", promotion);
}
async function updatePromotion(promotion) {
  return await put(`/discount_codes/${promotion.discount_code_id}`, promotion);
}
async function getPromotions() {
  return await get("/discount_codes");
}
async function getStats() {
  return await get("/discount_codes/stats");
}
function usePromotion() {
  const [state, setState] = useState([]);
  const promoQuery = useQuery({
    queryKey: ["promotion"],
    queryFn: getPromotions,
    onSuccess: (data) => setState(data),
  });

  const statsQuery = useQuery({
    queryKey: ["promotion_stats"],
    queryFn: getStats,
  });
  const postMutation = useMutation({
    mutationFn: addPromotion,
    onSuccess: () =>
      queryClient.invalidateQueries(["promotion_stats", "promotion"]),
  });

  const putMutation = useMutation({
    mutationFn: updatePromotion,
    onSuccess: () =>
      queryClient.invalidateQueries(["promotion_stats", "promotion"]),
  });
  return {
    state,
    active: state.filter((x) => new Date(x.expiration_date) > new Date()),
    promoQuery,
    statsQuery,
    addPromotion: (promo) => postMutation.mutate(promo),
    updatePromotion: (promo) => putMutation.mutate(promo),
  };
}
export default usePromotion;
